// extracted by mini-css-extract-plugin
export default {"card-info":"styles_card-info__R7m1v","flex-container":"styles_flex-container__2ohc1","name":"styles_name__ibjjC"};